import { Navigate, Outlet, useLocation } from 'react-router-dom';

/**
 * Layout wrapper for the Global Settings section. Redirects the bare
 * /global-settings path straight to the first sub-page.
 */
export function GlobalSettingsLayout() {
  const { pathname } = useLocation();
  if (pathname === '/global-settings' || pathname === '/global-settings/') {
    return <Navigate to="/global-settings/document-management" replace />;
  }
  return <Outlet />;
}
